import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { downloadCsv } from "@/lib/intelligenceExport";
import { toast } from "sonner";

type Props = {
	filename: string;
	buildRows: () => (string | number | null | undefined)[][] | null;
	disabled?: boolean;
	label?: string;
};

export function IntelligenceExportButton({
	filename,
	buildRows,
	disabled,
	label = "Export CSV",
}: Props) {
	const handleExport = () => {
		try {
			const rows = buildRows();
			if (!rows || rows.length === 0) {
				toast.error("Nothing to export");
				return;
			}
			downloadCsv(filename, rows);
			toast.success("CSV downloaded");
		} catch (e) {
			toast.error((e as Error)?.message ?? "Export failed");
		}
	};

	return (
		<Button
			type="button"
			variant="outline"
			size="sm"
			onClick={handleExport}
			disabled={disabled}
			className="gap-2"
		>
			<Download className="h-4 w-4" />
			{label}
		</Button>
	);
}
